import { Component, OnInit, Compiler } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../service/commons-service';
import { AppConfig } from '../util';
@Component({
    templateUrl: 'adminDashboard.component.html',
    styleUrls: ['adminDashboard.component.css']
})

export class AdminDashboardComponent implements OnInit {
     loginImageURL: any = "";
     loginUserName: any = "";
     towerName: any = "";
     superUserType: any = "";
     loading: boolean = false;

    constructor(private commonService: CommonService,
        private router: Router,
        private appConfig: AppConfig,
        private _compiler: Compiler) {
        this._compiler.clearCache();
        let users = JSON.parse(localStorage.getItem('user'));
        if (!users || !users.userData) {
            commonService.logout();
            return;
        }
        if (users && users.userData) {
            this.loginUserName = users.userData.displayName;
            this.towerName = localStorage.getItem('towerName');
        }
        if (localStorage.getItem('superUserType')) {
            this.superUserType = localStorage.getItem('superUserType');
        }
        this.loginImageURL = this.appConfig.getDefaultImgURL();
    }

    ngOnInit() {
    }

    public gotoNextPage(e, routeURL) {
        this.router.navigate([routeURL]);
    }
}